import app from 'flarum/forum/app';
import applyThemeLargeClass from './applyThemeLargeClass';
import addThemeLargeSetting from './addThemeLargeSetting';
app.initializers.add('champis-theme-large', () => {
  applyThemeLargeClass();
  addThemeLargeSetting();
});